/**
 * 阴影配置
 * 基于ERC-721 Premium Asset Platform的高端阴影系统
 * 体现独特性、稀有性和高价值的视觉层次
 */
// @mui
import { alpha } from '@mui/material/styles';
//
import palette from './palette';

// ----------------------------------------------------------------------

const LIGHT_MODE = palette.light.grey[500];
const DARK_MODE = '#000000';

const createShadow = (color) => {
  const transparent1 = alpha(color, 0.2);
  const transparent2 = alpha(color, 0.14);
  const transparent3 = alpha(color, 0.12);
  return [
    'none',
    `0px 2px 1px -1px ${transparent1},0px 1px 1px 0px ${transparent2},0px 1px 3px 0px ${transparent3}`,
    `0px 3px 1px -2px ${transparent1},0px 2px 2px 0px ${transparent2},0px 1px 5px 0px ${transparent3}`,
    `0px 3px 3px -2px ${transparent1},0px 3px 4px 0px ${transparent2},0px 1px 8px 0px ${transparent3}`,
    `0px 2px 4px -1px ${transparent1},0px 4px 5px 0px ${transparent2},0px 1px 10px 0px ${transparent3}`,
    `0px 3px 5px -1px ${transparent1},0px 5px 8px 0px ${transparent2},0px 1px 14px 0px ${transparent3}`,
    `0px 3px 5px -1px ${transparent1},0px 6px 10px 0px ${transparent2},0px 1px 18px 0px ${transparent3}`,
    `0px 4px 5px -2px ${transparent1},0px 7px 10px 1px ${transparent2},0px 2px 16px 1px ${transparent3}`,
    `0px 5px 5px -3px ${transparent1},0px 8px 10px 1px ${transparent2},0px 3px 14px 2px ${transparent3}`,
    `0px 5px 6px -3px ${transparent1},0px 9px 12px 1px ${transparent2},0px 3px 16px 2px ${transparent3}`,
    `0px 6px 6px -3px ${transparent1},0px 10px 14px 1px ${transparent2},0px 4px 18px 3px ${transparent3}`,
    `0px 6px 7px -4px ${transparent1},0px 11px 15px 1px ${transparent2},0px 4px 20px 3px ${transparent3}`,
    `0px 7px 8px -4px ${transparent1},0px 12px 17px 2px ${transparent2},0px 5px 22px 4px ${transparent3}`,
    `0px 7px 8px -4px ${transparent1},0px 13px 19px 2px ${transparent2},0px 5px 24px 4px ${transparent3}`,
    `0px 7px 9px -4px ${transparent1},0px 14px 21px 2px ${transparent2},0px 5px 26px 4px ${transparent3}`,
    `0px 8px 9px -5px ${transparent1},0px 15px 22px 2px ${transparent2},0px 6px 28px 5px ${transparent3}`,
    `0px 8px 10px -5px ${transparent1},0px 16px 24px 2px ${transparent2},0px 6px 30px 5px ${transparent3}`,
    `0px 8px 11px -5px ${transparent1},0px 17px 26px 2px ${transparent2},0px 6px 32px 5px ${transparent3}`,
    `0px 9px 11px -5px ${transparent1},0px 18px 28px 2px ${transparent2},0px 7px 34px 6px ${transparent3}`,
    `0px 9px 12px -6px ${transparent1},0px 19px 29px 2px ${transparent2},0px 7px 36px 6px ${transparent3}`,
    `0px 10px 13px -6px ${transparent1},0px 20px 31px 3px ${transparent2},0px 8px 38px 7px ${transparent3}`,
    `0px 10px 13px -6px ${transparent1},0px 21px 33px 3px ${transparent2},0px 8px 40px 7px ${transparent3}`,
    `0px 10px 14px -6px ${transparent1},0px 22px 35px 3px ${transparent2},0px 8px 42px 7px ${transparent3}`,
    `0px 11px 14px -7px ${transparent1},0px 23px 36px 3px ${transparent2},0px 9px 44px 8px ${transparent3}`,
    `0px 11px 15px -7px ${transparent1},0px 24px 38px 3px ${transparent2},0px 9px 46px 8px ${transparent3}`,
  ];
};

const createCustomShadow = (color) => {
  const transparent = alpha(color, 0.16);
  return {
    // 基础阴影 - ERC-721 高端风格
    basic: {
      // 轻微阴影 - 精致感
      light: '0 2px 4px rgba(0, 102, 255, 0.08), 0 1px 2px rgba(138, 43, 226, 0.06)',
      // 标准阴影 - 层次感
      medium: '0 4px 8px rgba(0, 102, 255, 0.12), 0 2px 4px rgba(138, 43, 226, 0.08)',
      // 深度阴影 - 高端感
      heavy: '0 8px 16px rgba(0, 102, 255, 0.16), 0 4px 8px rgba(138, 43, 226, 0.12)',
      // 极深阴影 - 奢华感
      extreme: '0 16px 32px rgba(0, 102, 255, 0.20), 0 8px 16px rgba(138, 43, 226, 0.16)',
    },
    // ERC-721 专属彩色阴影
    colored: {
      // 主色阴影 - 蓝色科技感
      primary: '0 6px 20px 0 rgba(0, 102, 255, 0.35)',
      // 次色阴影 - 紫色神秘感
      secondary: '0 6px 20px 0 rgba(138, 43, 226, 0.35)',
      // 金色阴影 - 奢华感
      gold: '0 6px 20px 0 rgba(255, 215, 0, 0.40)',
      // 成功色阴影 - 绿色增值感
      success: '0 6px 20px 0 rgba(76, 175, 80, 0.35)',
      // 警告色阴影 - 橙色注意感
      warning: '0 6px 20px 0 rgba(255, 152, 0, 0.35)',
      // 错误色阴影 - 红色警示感
      error: '0 6px 20px 0 rgba(244, 67, 54, 0.35)',
      // 信息色阴影 - 蓝色信息感
      info: '0 6px 20px 0 rgba(33, 150, 243, 0.35)',
      // 稀有度阴影 - 彩虹渐变
      rare: '0 8px 24px 0 rgba(255, 215, 0, 0.25), 0 4px 12px 0 rgba(138, 43, 226, 0.25)',
    },
    z1: `0 1px 2px 0 ${transparent}`,
    z8: `0 8px 16px 0 ${transparent}`,
    z12: `0 12px 24px -4px ${transparent}`,
    z16: `0 16px 32px -4px ${transparent}`,
    z20: `0 20px 40px -4px ${transparent}`,
    z24: `0 24px 48px 0 ${transparent}`,
    // ERC-721 专属阴影效果
    nftCard: `0 4px 12px 0 ${alpha(color, 0.15)}, 0 16px 32px -4px ${alpha(color, 0.10)}`,
    premiumCard: `0 8px 24px 0 ${alpha(color, 0.20)}, 0 20px 40px -4px ${alpha(color, 0.15)}`,
    luxuryCard: `0 12px 36px 0 ${alpha(color, 0.25)}, 0 24px 48px -4px ${alpha(color, 0.20)}`,
    rareGlow: `0 0 20px ${alpha('#FFD700', 0.4)}, 0 0 40px ${alpha('#8A2BE2', 0.2)}`,
    
    // 原有阴影效果
    card: `0 0 2px 0 ${alpha(color, 0.2)}, 0 12px 24px -4px ${alpha(color, 0.12)}`,
    dialog: `-40px 40px 80px -8px ${alpha(palette.light.common.black, 0.24)}`,
    dropdown: `0 0 2px 0 ${alpha(color, 0.24)}, -20px 20px 40px -4px ${alpha(color, 0.24)}`,
  };
};

export const customShadows = {
  light: createCustomShadow(LIGHT_MODE),
  // ERC-721 暗色模式高端阴影
  dark: {
    z1: '0 1px 2px 0 rgba(0, 0, 0, 0.48)',
    z8: '0 8px 16px 0 rgba(0, 0, 0, 0.48)',
    z12: '0 12px 24px -4px rgba(0, 0, 0, 0.48)',
    z16: '0 16px 32px -4px rgba(0, 0, 0, 0.48)',
    z20: '0 20px 40px -4px rgba(0, 0, 0, 0.48)',
    z24: '0 24px 48px 0 rgba(0, 0, 0, 0.48)',
    
    // ERC-721 专属暗色阴影
    primary: `0 8px 16px 0 ${alpha('#000000', 0.48)}`,
    secondary: `0 8px 16px 0 ${alpha('#000000', 0.48)}`,
    gold: '0 8px 20px 0 rgba(255, 215, 0, 0.35)',
    premium: '0 12px 28px 0 rgba(0, 102, 255, 0.25), 0 6px 14px 0 rgba(138, 43, 226, 0.20)',
    luxury: '0 16px 36px 0 rgba(255, 215, 0, 0.30), 0 8px 18px 0 rgba(138, 43, 226, 0.25)',
    rare: '0 0 24px rgba(255, 215, 0, 0.45), 0 0 48px rgba(138, 43, 226, 0.25)',
    
    // NFT 卡片专属阴影
    nftCard: '0 4px 16px 0 rgba(0, 0, 0, 0.25), 0 16px 36px -4px rgba(0, 102, 255, 0.15)',
    premiumCard: '0 8px 28px 0 rgba(0, 0, 0, 0.30), 0 20px 44px -4px rgba(138, 43, 226, 0.20)',
    luxuryCard: '0 12px 40px 0 rgba(0, 0, 0, 0.35), 0 24px 52px -4px rgba(255, 215, 0, 0.25)',
    
    // 原有阴影效果
    card: '0 0 2px 0 rgba(0, 0, 0, 0.2), 0 12px 24px -4px rgba(0, 0, 0, 0.12)',
    dropdown: '0 0 2px 0 rgba(0, 0, 0, 0.24), -20px 20px 40px -4px rgba(0, 0, 0, 0.24)',
    
    // 基础阴影 - ERC-721 高端风格
    basic: {
      // 轻微阴影 - 精致感
      light: '0 2px 4px rgba(0, 102, 255, 0.08), 0 1px 2px rgba(138, 43, 226, 0.06)',
      // 标准阴影 - 层次感
      medium: '0 4px 8px rgba(0, 102, 255, 0.12), 0 2px 4px rgba(138, 43, 226, 0.08)',
      // 深度阴影 - 高端感
      heavy: '0 8px 16px rgba(0, 102, 255, 0.16), 0 4px 8px rgba(138, 43, 226, 0.12)',
      // 极深阴影 - 奢华感
      extreme: '0 16px 32px rgba(0, 102, 255, 0.20), 0 8px 16px rgba(138, 43, 226, 0.16)',
    },
    // ERC-721 专属彩色阴影
    colored: {
      // 主色阴影 - 蓝色科技感
      primary: '0 6px 20px 0 rgba(0, 102, 255, 0.35)',
      // 次色阴影 - 紫色神秘感
      secondary: '0 6px 20px 0 rgba(138, 43, 226, 0.35)',
      // 金色阴影 - 奢华感
      gold: '0 6px 20px 0 rgba(255, 215, 0, 0.40)',
      // 成功色阴影 - 绿色增值感
      success: '0 6px 20px 0 rgba(76, 175, 80, 0.35)',
      // 警告色阴影 - 橙色注意感
      warning: '0 6px 20px 0 rgba(255, 152, 0, 0.35)',
      // 错误色阴影 - 红色警示感
      error: '0 6px 20px 0 rgba(244, 67, 54, 0.35)',
      // 信息色阴影 - 蓝色信息感
      info: '0 6px 20px 0 rgba(33, 150, 243, 0.35)',
      // 稀有度阴影 - 彩虹渐变
      rare: '0 8px 24px 0 rgba(255, 215, 0, 0.25), 0 4px 12px 0 rgba(138, 43, 226, 0.25)',
    },
  },
};

const shadows = {
  light: createShadow(LIGHT_MODE),
  dark: createShadow(DARK_MODE),
};

export default shadows;
